import { StateCreator } from "zustand";
import { IMirageApplications } from "@shared/mirage/core/IMirageApplications";

export interface CurrentApplicationSlice {
    currentApplication: IMirageApplications;
    setCurrentApplication: (app: IMirageApplications) => void;
}

export const createCurrentApplicationSlice: StateCreator<CurrentApplicationSlice, [], [], CurrentApplicationSlice> = (set) => ({
    currentApplication: "" as IMirageApplications,

    setCurrentApplication: (app) => set({ currentApplication: app }),
});
